import { toast } from "react-toastify";
import instance from "../config/axios";
import { base_apis } from "../config/url";

export const loginWithToken = (data) => {
     return instance.post(`${base_apis.login}`, data)
          .then((res) => {
               return res;
          });
};

export const getFreeAvatar = (data) => {
     return instance.post(`${base_apis.freeAvatar}`, data)
          .then((res) => {
               return res;
          });
};

// export const firstTimeProfileUpdate = (data, viToken) => {
//      return instance.post(`${base_apis.ftProfileUpdate}`, data)
//           .then((res) => {
//                return res;
//           });
// };

export const firstTimeProfileUpdate = (data, viToken) => {
     console.log('firstTimeProfileUpdate', viToken)
     let tempInstance = instance;

     // Set the x-access-token header
     tempInstance.defaults.headers['x-access-token'] = viToken;

     return tempInstance.post(`${base_apis.ftProfileUpdate}`, data)
          .then((res) => {
               return res;
          });
};

export const userWallet = (data) => {
     return instance.post(`${base_apis.user}/profile`, data)
          .then((res) => {
               return res;
          });
};

export const userWalletLimit = (data) => {
     return instance.post(`${base_apis.user}/walletLimit`, data)
          .then((res) => {
               return res;
          });
};

export const userUpdateProfile = (data) => {
     return instance.post(`${base_apis.user}/update/profile`, data)
          .then((res) => {
               return res;
          });
};

export const userByPhone = (data) => {
     return instance.post(`${base_apis.userInGameName}/byUser`, data)
          .then((res) => {
               return res;
          });
};

export const getWalletLimit = (data) => {
     return instance.post(`${base_apis.walletLimit}`, data)
          .then((res) => {
               return res;
          });
};

export const userByToken = () => {
     return instance.get(`${base_apis.getByToken}`)
          .then((res) => {
               return res;
          });
};



export const easeBuzzPaymentStatus = (data) => {
     return instance
          .post(`${base_apis.easeBuzzPaymentStatus}`, data)
          .then((res) => {
               return res;
          });
   };

export const easeBuzzHash = async (data) => {
     try {
          console.log('easeBuzzHash:data', data);
          const response = await instance.post(`${base_apis.easeBuzzHash}`, data);
          // console.log('easeBuzzHash:response', response);
          return response;
     } catch (error) {
          console.error('Error in easeBuzzHash:', error);
          const errorMessage = error?.response?.data?.errors?.[0]?.msg || 
                              error?.response?.data?.message || 
                              'Failed to generate hash for EaseBuzz payment.';
          // toast.error(errorMessage);
          const customError = new Error(errorMessage);
          customError.originalError = error;
          throw customError;
     }
};
